/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

const CustomCacheConfig =
{
	Customer: { Record: { maxAge: 60 * 60 * 24 * 1000, maxLength: 1 }, List: { maxAge: 60 * 60 * 24 * 1000, maxLength: 100 } },
	Material: { Record: { maxAge: 30 * 1000 }, List: { maxAge: 30 * 1000 } },
	LineItem: { Record: { maxAge: 30 * 1000 }, List: { maxAge: 30 * 1000 } },
	Sample: { Record: { maxAge: 30 * 1000 }, List: { maxAge: 30 * 1000 } },
};

class EntityCacheConfigurationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	onInitialize()
	{
		for (const [ entity, optionTypes ] of Object.entries(CustomCacheConfig))
		{
			this.pict.EntityProvider.initializeCache(entity);
			if (optionTypes.Record)
			{
				if (optionTypes.Record.maxAge)
				{
					this.pict.EntityProvider.recordCache[entity].maxAge = optionTypes.Record.maxAge;
				}
				if (optionTypes.Record.maxLength)
				{
					this.pict.EntityProvider.recordCache[entity].maxLength = optionTypes.Record.maxLength;
				}
			}
			if (optionTypes.List)
			{
				if (optionTypes.List.maxAge)
				{
					this.pict.EntityProvider.recordSetCache[entity].maxAge = optionTypes.List.maxAge;
				}
				if (optionTypes.List.maxLength)
				{
					this.pict.EntityProvider.recordSetCache[entity].maxLength = optionTypes.List.maxLength;
				}
			}
		}
		return super.onInitialize();
	}
}

module.exports = EntityCacheConfigurationProvider;
module.exports.default_configuration = {};
